// Import all of the Bootstrap JS
//import 'bootstrap';
// Or just load the pieces you need
import 'bootstrap/js/src/util';
//import 'bootstrap/js/src/alert';
//import 'bootstrap/js/src/button';
//import 'bootstrap/js/src/carousel';
import 'bootstrap/js/src/collapse';
//import 'bootstrap/js/src/dropdown';
import 'bootstrap/js/src/modal';
//import 'bootstrap/js/src/popover';
//import 'bootstrap/js/src/scrollspy';
//import 'bootstrap/js/src/tab';
////import 'bootstrap/js/src/toast';
//import 'bootstrap/js/src/tooltip';

import './skip-link-focus-fix.js';
import './header-search-toggle.js';
import './ajax-load-more-filter.js';
import './sticky-header.js';
import './wp-navigation-block-shim.js';
import './max-mega-menu.js';
import './tertiary-mobile-menu';
import './faq-block';
import './modals';
import './customer-center-menu';
import './social-share';
import './testimonials';
import './single-press-nav-active-state.js';

jQuery.migrateMute = true;
